import localeAntd from 'antd/es/locale/en_US'
import messages from './localization-en-US.json'

export default {
  locale: 'en-US',
  localeAntd,
  messages,
}